import axios from 'axios';
import { constructServiceURL } from '../../../../../utils/URLTools';

export const apiFetchGlobalPresetImpc = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getGlobalImpcAssetPreset',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
    },
  });
  return axios.get(serviceUrl);
};

export const apiFetchGlobalPresetOperator = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getGlobalOperatorAssetPreset',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
    },
  });
  return axios.get(serviceUrl);
};
